/* recovered from production bundle — components/auth/LoginPage.tsx */
// @ts-nocheck

import React from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../lib/api';
import { appConfig } from '../../lib/config';
import { setToken } from '../../lib/auth';
import { displayHostPort } from '../../lib/mobile';
import * as Icons from '../../icons';

export function LoginPage({ onLogin: onLoginCb }) {
  const { t } = useTranslation('auth');
  const [email, setEmail] = React.useState(appConfig.defaultLoginEmail);
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const port = typeof window !== 'undefined'
    ? displayHostPort({ protocol: window.location.protocol, port: window.location.port })
    : '';

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    setError('');
    try {
      const res = await api.login(email, password);
      setToken(res.token);
      onLoginCb();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gradient-to-br from-nv-bg to-[#e0e8f0] px-4 nv-safe-pad">
      <div className="w-full max-w-sm p-8 bg-nv-panel rounded-lg shadow-xl border border-nv-border">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-lg bg-nv-accent flex items-center justify-center">
            <Icons._Component className="w-7 h-7 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-semibold">{appConfig.appTitle}</h1>
            <p className="text-nv-textSubtle text-xs">{appConfig.appSubtitle}</p>
            <p className="text-2xs text-nv-textMuted mt-0.5">
              {t('backendPort', { stack: appConfig.stack, port })}
            </p>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-xs text-nv-textSubtle mb-1">{t('username')}</label>
            <input type="text" value={email} onChange={(c) => setEmail(c.target.value)} className="nv-input w-full" autoFocus />
          </div>
          <div>
            <label className="block text-xs text-nv-textSubtle mb-1">{t('password')}</label>
            <input type="password" value={password} onChange={(c) => setPassword(c.target.value)} className="nv-input w-full" required />
          </div>
          {error && <p className="text-nv-danger text-xs">{error}</p>}
          <button type="submit" disabled={busy} className="nv-btn-primary w-full justify-center py-3 min-h-[44px]">
            {busy ? t('signingIn') : t('signIn')}
          </button>
        </form>
      </div>
    </div>
  );
}
